module.exports = __webpack_public_path__ + "img/10.fc4a7341.png";